import "../Css/contact.css";
import React, { useEffect, useState } from "react";
import Download from "../Assets/download.svg";

function StickyCTA({ footerId = "contact", headerId = "hero-header" }) {
  const [pastHeader, setPastHeader] = useState(false);
  const [beforeFooter, setBeforeFooter] = useState(true);

  useEffect(() => {
    const headerEl = document.getElementById(headerId);
    if (!headerEl) return;

    const headerObserver = new IntersectionObserver(
      ([entry]) => {
        // becomes true once the header has fully scrolled out of view
        setPastHeader(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    headerObserver.observe(headerEl);
    return () => headerObserver.disconnect();
  }, [headerId]);

  useEffect(() => {
    const footerEl = document.getElementById(footerId);
    if (!footerEl) return;

    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        setBeforeFooter(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    footerObserver.observe(footerEl);
    return () => footerObserver.disconnect();
  }, [footerId]);

  const visible = pastHeader && beforeFooter;

  return (
    <div className={`sticky-cta ${visible ? "visible" : "hidden"}`}>
      <span className="sticky-cta-text">Peeked your Interest? Let's Talk</span>
      <div className="sticky-cta-actions">
        <a href="mailto:harshitsharma34@gmail.com" className="sticky-cta-btn ghost">
          <span role="img" aria-label="waving hand">👋</span> Drop a Hi!
        </a>
        <a href="https://drive.google.com/file/d/1W9yKH0KnOzj0OpzF1r-WkanICqnlnoTU/view?usp=sharing" className="sticky-cta-btn filled" target="_blank" rel="noopener noreferrer">
          <img src={Download} alt="" className="btn-icon" style={{ color: "white" }} />
          Download Resume
        </a>
      </div>
    </div>
  );
}

export default StickyCTA;